import Guard from "vue-router-multiguard";
import { Middlewares } from "@/app/shared/services/app-router/middlewares";

export default [
    {
        path: "/deliveries",
        name: "DeliveryList",
        component: () => import("./views/deliveryList.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
